import Icon from '@material-ui/icons/MovieFilter';

import List from './List';

export default {
  name: 'reports/episode',
  icon: Icon,
  list: List,
};
